import React from "react";
import { GLBANOTICELINK } from "Utils/EnvVars";
import { faro } from "@grafana/faro-react";
import "./Footer.scss";
import { Box } from "@mui/material";
import { PRIVACY_POLICY_LINK } from "Utils/Constants";

export default function Footer({ isCashier }) {
  const linkClick = (link) =>
    faro.api.pushEvent(`User clicked on ${link} in footer`);

  return (
    <Box
      sx={{
        width: "100vw",
        display: "flex",
        position: isCashier ? "relative" : "fixed",
        marginTop: "50px",
        bottom: 0,
        left: 0,
        flexDirection: "column",
      }}
    >
      <Box
        className="footer"
        sx={{
          padding: isCashier
            ? "16px var(--spacing-4xl) 16px var(--spacing-2xl)"
            : "16px var(--spacing-4xl)",
        }}
      >
        <a
          rel="noreferrer"
          target="_blank"
          href={PRIVACY_POLICY_LINK}
          onClick={() => linkClick("Privacy Notice")}
        >
          Privacy Notice
        </a>
        <Box>|</Box>
        <a
          rel="noreferrer"
          target="_blank"
          href={GLBANOTICELINK}
          onClick={() => linkClick("GLBA Notice")}
        >
          GLBA Notice
        </a>
      </Box>
    </Box>
  );
}
